import React from 'react';
import PropTypes from 'prop-types';
import DaysLinks from '../days-links';
import BackLink from '../back-link';
import TicketsPanels from './tickets-panels';
import PopupLink from '../popup-link';
import { ROUTE_DAYS } from '../constants';
import PopupLinkInfo from '../popup-link-info';
import { hasValue } from '../../../../general/js/general-helpers';

export default class SelectTicketsFormHospitality extends React.Component {
    constructor(props) {
        super(props);
        this.formHeading = React.createRef();
    }

    componentDidMount() {
        this.formHeading.current.focus();
    }

    render() {
        return (
            <div className="tb-form">
                <h2 className="tb-form__heading headline" tabIndex="-1" ref={this.formHeading}>{this.props.categoriesList[0].title}</h2>
                <DaysLinks productGroupsList={this.props.productGroupsList} />
                <div className="tb-form__header">
                    <h3 className="title">{this.props.dictionary.selectTicketsSubtitle}</h3>
                    {
                        hasValue(this.props.dictionary.ticketsInformationLinkUrl) &&
                        hasValue(this.props.dictionary.ticketsInformationLinkText) &&
                        <PopupLinkInfo
                            href={this.props.dictionary.ticketsInformationLinkUrl}>{this.props.dictionary.ticketsInformationLinkText}</PopupLinkInfo>
                    }
                </div>
                <TicketsPanels
                    dictionary={this.props.dictionary}
                    ticketsList={this.props.ticketsList}
                    productGroupsList={this.props.productGroupsList}
                    onApplyProductsQuantity={this.props.onApplyProductsQuantity}
                    quantityModifier={this.props.quantityModifier}
                />
                <div className="tb-form__footer">
                    <div className="tb-form__footer-copy copy">
                        {this.props.dictionary.selectHospitalityTicketsText}&nbsp;
                        {
                            hasValue(this.props.dictionary.selectHospitalityTicketsLinkUrl) &&
                            hasValue(this.props.dictionary.selectHospitalityTicketsLinkText) &&
                            <PopupLink
                                className="tb-form__footer-link link"
                                href={this.props.dictionary.selectHospitalityTicketsLinkUrl}
                                ariaLabel="see full price">{this.props.dictionary.selectHospitalityTicketsLinkText}</PopupLink>
                        }
                    </div>
                    {
                        (hasValue(this.props.dictionary.selectHospitalityTicketsInstructionsText1) ||
                        hasValue(this.props.dictionary.selectHospitalityTicketsInstructionsText2)) &&
						<div className="tb-form__footer-second-copy copy">
						    {this.props.dictionary.selectHospitalityTicketsInstructionsText1}
						    {
						        hasValue(this.props.dictionary.selectHospitalityTicketsInstructionsLinkText) &&
                                hasValue(this.props.dictionary.selectHospitalityTicketsInstructionsLinkUrl) &&
                                <a className="tb-form__footer-link link"
						            href={this.props.dictionary.selectHospitalityTicketsInstructionsLinkUrl}
						            aria-label="Edit basket"
						            id="editBasket">{this.props.dictionary.selectHospitalityTicketsInstructionsLinkText}</a>
						    }
						    {this.props.dictionary.selectHospitalityTicketsInstructionsText2}
						</div>
                    }
                    <div className="tb-form__change-step">
                        <BackLink route={ROUTE_DAYS}>Back</BackLink>
                    </div>
                </div>
            </div>
        );
    }
}

SelectTicketsFormHospitality.propTypes = {
    dictionary: PropTypes.object.isRequired,
    categoriesList: PropTypes.array,
    productGroupsList: PropTypes.array,
    ticketsList: PropTypes.array,
    onApplyProductsQuantity: PropTypes.func,
    onClearSelection: PropTypes.func,
};
